import { CartItemFragment as CartItemFragmentType } from '@/features/graphql/generated/graphql'
import { CartItemFragment } from '@/features/pos/components/Cart/fragments/cartItem'
import { useFragment } from '@apollo/client'

export const useCartItemCache = (
    id: string | null | undefined = null
): CartItemFragmentType | undefined => {
    const { data, complete } = useFragment({
        fragment: CartItemFragment,
        fragmentName: 'CartItem',
        from: { __typename: 'CartItem', uuid: id },
    })

    return complete ? data : undefined
}
